enum MenuIdEnum {
    HOME = "home",
    ORDERS = "orders",
    SHIPMENTS = "shipments",
    DASHBOARD = "dashboard",
    BUSINESS = "business",
    PROFILE = "profile",
    PURCHASE_ORDERS = "purchase_orders",
    ORDERS_BATCH = "orders_batch",
    PRICE_APPROVAL = "price_approval",
    CATALOGS = "catalogs",
    UOM_SETS = "uom_sets_abbr",
    LABELS = "labels",
    VENDOR_SOURCES = "vendor_sources",
    DISCOUNTS = "discounts",
    MATERIALS = "materials",
    REP_GROUPS = "rep_groups",
    ROUTES = "routes",
    DAILY_ROUTES = "daily_routes",
    PICK_LISTS = "pick_lists",
    PACKING_LISTS = "packing_lists",
    BUSINESS_INTEGRATIONS = "business_integrations",
    BUSINESS_SETTINGS = "business_settings",
    REBATES = "rebates",
    COMMISSIONS = "commissions",
    SPIFF = "spiff",
    CLIENTS = "clients",
    SHIPMENT_BATCH = "shipment_batch",
    PROJECTS = "projects",
    TEMPLATES = "templates",
    QUOTES = "quotes",
    TAKE_OFFS = "take_offs",
    ACCOUNTING = "accounting",
    FORECAST = "forecast",
    CACHE = "cache",
    SYNC = "sync",
    INVENTORY = "inventory",
    REPORTS = "reports",
    ACCOUNTS = "accounts",
    EXPORTS = "exports",
    USERS = "users",
    PRODUCTION_DASHBOARD = "production_dashboard",
}

export default MenuIdEnum;
